export const addPrivateUserMessage = (
  text,
  displayName,
  senderId,
  selectedPeerId
) => ({
  type: "ADD_NEW_PRIVATE_USER_MESSAGE",
  payload: { text, displayName, senderId, selectedPeerId },
});

export const addPrivateResponseMessage = (message, peerId) => ({
  type: "ADD_NEW_PRIVATE_RESPONSE_MESSAGE",
  payload: { message, peerId },
});

export const addPrivateChatHistory = (privateChatHistory) => ({
  type: "ADD_PRIVATE_CHAT_HISTORY",
  payload: { privateChatHistory },
});

export const clearState = () => ({
  type: "CLEAR_STATE",
});
